/*
 *
 * FileRecollectionDrawer constants
 *
 */

export const SET_FILE_RECOLLECTION_DATA =
  'app/FileRecollectionDrawer/SET_FILE_RECOLLECTION_DATA';
